import { observer } from 'mobx-react'

import { TermsAndConditions } from '@components/TermsAndConditions/TermsAndConditions'

export const TermsAndConditionsPage = observer(() => {
  return <TermsAndConditions />
})
